/**
 * @fileoverview added by tsickle
 * Generated from: util/serializers.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { cloneDeep, isFunction, isObject, get as lodashGet, set as lodashSet, noop } from 'lodash-es';
import * as moment from 'moment';
import { baseObject } from './base-object';
import { DATE_FORMAT, toDate, toTime } from './datetime/index';
import { model } from './model';
import { camelToUnder, underToCamel } from './object-transforms';
/**
 * @record
 */
export function AnyObject() { }
/**
 * @record
 */
export function SerializeSingleOpts() { }
if (false) {
    /** @type {?|undefined} */
    SerializeSingleOpts.prototype.many;
}
/**
 * @record
 */
export function SerializeMultipleOpts() { }
if (false) {
    /** @type {?} */
    SerializeMultipleOpts.prototype.many;
}
/**
 * @record
 */
export function SerializerFields() { }
/**
 * @record
 */
export function SerializerExtendArgs() { }
if (false) {
    /** @type {?|undefined} */
    SerializerExtendArgs.prototype.fields;
    /* Skipping unhandled member: [key: string]: any;*/
}
/**
 * @record
 * @template T
 */
export function ModelSerializerExtendArgs() { }
if (false) {
    /** @type {?|undefined} */
    ModelSerializerExtendArgs.prototype.model;
}
/**
 * @record
 * @template T
 */
export function Serializer() { }
if (false) {
    /** @type {?} */
    Serializer.prototype.fields;
    /** @type {?} */
    Serializer.prototype.extend;
    /** @type {?} */
    Serializer.prototype._callSingle;
    /**
     * @param {?} obj
     * @param {?=} opts
     * @return {?}
     */
    Serializer.prototype.serialize = function (obj, opts) { };
    /**
     * @param {?} collection
     * @param {?} opts
     * @return {?}
     */
    Serializer.prototype.serialize = function (collection, opts) { };
    /**
     * @param {?} objOrCollection
     * @param {?=} opts
     * @return {?}
     */
    Serializer.prototype.serialize = function (objOrCollection, opts) { };
    /**
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    Serializer.prototype.deserialize = function (data, opts) { };
    /**
     * @param {?} data
     * @param {?} opts
     * @return {?}
     */
    Serializer.prototype.deserialize = function (data, opts) { };
    /**
     * @param {?} data
     * @param {?=} opts
     * @return {?}
     */
    Serializer.prototype.deserialize = function (data, opts) { };
}
/**
 * @record
 * @template T
 */
export function ModelSerializer() { }
if (false) {
    /** @type {?|undefined} */
    ModelSerializer.prototype.model;
    /** @type {?} */
    ModelSerializer.prototype.extend;
}
/**
 * @record
 */
export function FieldCreateOpts() { }
if (false) {
    /** @type {?|undefined} */
    FieldCreateOpts.prototype.optional;
    /** @type {?|undefined} */
    FieldCreateOpts.prototype.serializerKwargs;
}
/**
 * @record
 */
export function ListFieldCreateOpts() { }
if (false) {
    /** @type {?} */
    ListFieldCreateOpts.prototype.childField;
}
/**
 * @record
 */
export function FloatFieldCreateOpts() { }
if (false) {
    /** @type {?|undefined} */
    FloatFieldCreateOpts.prototype.asString;
    /** @type {?|undefined} */
    FloatFieldCreateOpts.prototype.precision;
}
/**
 * @record
 */
export function MomentFieldCreateOpts() { }
if (false) {
    /** @type {?|undefined} */
    MomentFieldCreateOpts.prototype.fmt;
}
/**
 * @record
 */
export function DateTimeFieldCreateOpts() { }
if (false) {
    /** @type {?|undefined} */
    DateTimeFieldCreateOpts.prototype.iso;
}
/**
 * @record
 * @template T
 */
export function SerializerFieldCreateOpts() { }
if (false) {
    /** @type {?} */
    SerializerFieldCreateOpts.prototype.serializer;
}
/**
 * @record
 */
export function Field() { }
if (false) {
    /** @type {?} */
    Field.prototype.create;
    /** @type {?} */
    Field.prototype.serialize;
    /** @type {?} */
    Field.prototype.deserialize;
}
/**
 * @record
 */
export function ListField() { }
if (false) {
    /** @type {?} */
    ListField.prototype.create;
}
/**
 * @record
 */
export function FloatField() { }
if (false) {
    /** @type {?} */
    FloatField.prototype.create;
}
/**
 * @record
 */
export function MomentField() { }
if (false) {
    /** @type {?} */
    MomentField.prototype.create;
}
/**
 * @record
 */
export function DateTimeField() { }
if (false) {
    /** @type {?} */
    DateTimeField.prototype.create;
}
/**
 * @record
 * @template T
 */
export function SerializerField() { }
if (false) {
    /** @type {?} */
    SerializerField.prototype.create;
}
var ɵ0 = /**
 * @return {?}
 */
function () {
    /** @type {?} */
    var console = window.console;
    return console ? console.error.bind(console) : noop;
};
/**
 * Report when errors occur.
 * @type {?}
 */
var error = ((ɵ0))();
/* eslint-disable no-unused-vars */
/**
 * Base Serializer Interface.
 * Allows objects to be (de)serialized prior to / after communicating
 * with the back-end.
 *
 * By default, all keys are transformed into camelCase within JS-space,
 * and underscore-delimited before being sent to the server.
 *
 * Serializers should extend this interface, and provide fields to help
 * with the serialisation process
 * @type {?}
 */
var baseSerializer = (/** @type {?} */ (baseObject.extend({
    /**
     * Public method to be used by the caller to serialize an object.
     */
    serialize: /**
     * Public method to be used by the caller to serialize an object.
     * @param {?} obj
     * @param {?=} kwargs
     * @return {?}
     */
    function (obj, kwargs) {
        if (kwargs === void 0) { kwargs = {}; }
        try {
            return this._call(obj, kwargs, 'serialize');
        }
        catch (e) {
            error("Failed serialisation of", obj, " because of error", e);
            throw e;
        }
    },
    /**
     * Interface for serializers to extend the serialisation process.
     * Called after the individual fields are transformed.
     * @param obj Object - The object being serialised
     * @param kwargs Object - Keyword arguments passed during serialisation
     * @return Object - The transformed object.
     */
    getSerialized: /**
     * Interface for serializers to extend the serialisation process.
     * Called after the individual fields are transformed.
     * @param {?} obj Object - The object being serialised
     * @return {?} Object - The transformed object.
     */
    function (obj) {
        return obj;
    },
    /**
     * Public method to be used by the caller to deserialize an object.
     * @param obj Object - The object to deserialize
     * @param kwargs Object - Keyword arguments to pass to the serializer
     * @return Object - The deserialized object
     */
    deserialize: /**
     * Public method to be used by the caller to deserialize an object.
     * @param {?} obj Object - The object to deserialize
     * @param {?=} kwargs Object - Keyword arguments to pass to the serializer
     * @return {?} Object - The deserialized object
     */
    function (obj, kwargs) {
        if (kwargs === void 0) { kwargs = {}; }
        try {
            return this._call(obj, kwargs, 'deserialize');
        }
        catch (e) {
            error("Failed deserialization of", obj, " because of error", e);
            throw e;
        }
    },
    /**
     * Interface for serializers to extend the deserialization process.
     * Called after the individual fields are transformed.
     * @param obj Object - The object being serialised
     * @param kwargs Object - Keyword arguments passed during serialisation
     * @return Object - The transformed object.
     */
    getDeserialized: /**
     * Interface for serializers to extend the deserialization process.
     * Called after the individual fields are transformed.
     * @param {?} obj Object - The object being serialised
     * @return {?} Object - The transformed object.
     */
    function (obj) {
        return obj;
    },
    /**
     * Filter out functions during the transform
     */
    _filterFunctions: /**
     * Filter out functions during the transform
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        return isFunction(obj);
    },
    /**
     * (De)serialize an object or collection of objects.
     * If the many keyword is passed, we serialize multiple. The majority
     * of the work is actually carried out in the _callSingle method below
     * to account for this.
     * @param obj Object|Array - The object or collection
     * @param kwargs Object - Keyword arguments passed during invocation
     * @param method string - The method to use - serialize or deserialize
     * @return Object|Array - The transformed object or collection
     */
    _call: /**
     * (De)serialize an object or collection of objects.
     * If the many keyword is passed, we serialize multiple. The majority
     * of the work is actually carried out in the _callSingle method below
     * to account for this.
     * @param {?} obj Object|Array - The object or collection
     * @param {?=} kwargs Object - Keyword arguments passed during invocation
     * @param {?=} method string - The method to use - serialize or deserialize
     * @return {?} Object|Array - The transformed object or collection
     */
    function (obj, kwargs, method) {
        var _this = this;
        if (kwargs === void 0) { kwargs = {}; }
        if (kwargs.many) {
            return obj.map((/**
             * @param {?} single
             * @return {?}
             */
            function (single) { return _this._callSingle(single, kwargs, method); }));
        }
        else {
            return this._callSingle(obj, kwargs, method);
        }
    },
    /**
     * (De)serialize a single object.
     * @param obj Object  - Object to transform
     * @param kwargs Object  - Keyword arguments passed during invocation
     * @param method string  - The method to use - serialize or deserialize
     * @return Object The transformed object.
     */
    _callSingle: /**
     * (De)serialize a single object.
     * @param {?} obj Object  - Object to transform
     * @param {?=} kwargs Object  - Keyword arguments passed during invocation
     * @param {?=} method string  - The method to use - serialize or deserialize
     * @return {?} Object The transformed object.
     */
    function (obj, kwargs, method) {
        var _this = this;
        if (kwargs === void 0) { kwargs = {}; }
        /** @type {?} */
        var objOut;
        if (method === 'serialize') {
            objOut = camelToUnder(obj, this._filterFunctions);
        }
        else {
            objOut = cloneDeep(obj);
        }
        // Add the current object to the kwargs for the field serializer
        /** @type {?} */
        var fieldKwargs = Object.assign({ obj: obj }, kwargs);
        this._getFields().forEach((/**
         * @param {?} field
         * @return {?}
         */
        function (field) {
            _this._callField({ field: field, method: method, objOut: objOut, kwargs: fieldKwargs });
        }));
        if (method === 'deserialize') {
            objOut = underToCamel(objOut, this._filterFunctions);
        }
        /** @type {?} */
        var fnName = method === 'serialize' ? 'getSerialized' : 'getDeserialized';
        if (isFunction(this[fnName])) {
            objOut = this[fnName](objOut, kwargs);
        }
        return objOut;
    },
    /**
     * Find and return the fields used for the given serializer.
     */
    _getFields: /**
     * Find and return the fields used for the given serializer.
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var fields = [];
        if (isObject(this.fields)) {
            Object.keys(this.fields).forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                /** @type {?} */
                var field = _this.fields[key];
                field.src = key;
                fields.push(field);
            }));
        }
        return fields;
    },
    /**
     * (De)serialize a single field.
     * @param opts Object
     * @param opts.field Object
     * @param opts.method Object - Whether to serialise / deserialize
     * @param opts.objOut Object - The mutated version of the object
     * @param opts.kwargs Object - Keyword arguments to pass to the field
     */
    _callField: /**
     * (De)serialize a single field.
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var field = _a.field, method = _a.method, objOut = _a.objOut, kwargs = _a.kwargs;
        try {
            /** @type {?} */
            var value = lodashGet(objOut, field.src);
            if ((value === undefined || value === null) && field.optional) {
                return;
            }
            lodashSet(objOut, field.src, field[method](value, kwargs));
        }
        catch (e) {
            error("Failed to " + method + " field: " + field.src + " for object", kwargs.obj);
            throw e;
        }
    }
})));
/**
 * (De)serialize models.
 * @type {?}
 */
export var modelSerializer = (/** @type {?} */ (baseSerializer.extend({
    model: model,
    /**
     * Skip serialization when the model is representing by its string ID.
     */
    _callSingle: /**
     * Skip serialization when the model is representing by its string ID.
     * @param {?} obj
     * @param {?} kwargs
     * @param {?} method
     * @return {?}
     */
    function (obj, kwargs, method) {
        if (typeof obj === 'string') {
            return obj;
        }
        else {
            return baseSerializer._callSingle.call(this, obj, kwargs, method);
        }
    },
    getDeserialized: /**
     * @param {?} obj
     * @param {?} kwargs
     * @return {?}
     */
    function (obj, kwargs) {
        obj = this.preCreate(obj, kwargs);
        // No-create is useful for updating instances with new data.
        if (!kwargs.noCreate) {
            obj = this.model.create(obj, this.getCreateKwargs(obj, kwargs));
            obj = this.postCreate(obj, kwargs);
        }
        return obj;
    },
    /**
     * Interface for updating the object before creating the instance.
     * @param obj Object - The object to be used to instantiate the model
     * @param kwargs Object - Kwargs used during deserialization
     * @return Object - The modified data
     */
    preCreate: /**
     * Interface for updating the object before creating the instance.
     * @param {?} obj Object - The object to be used to instantiate the model
     * @return {?} Object - The modified data
     */
    function (obj) {
        var _this = this;
        Object.keys(obj).forEach((/**
         * @param {?} property
         * @return {?}
         */
        function (property) {
            if (!_this.model.canSet(property)) {
                error("Cannot set read-only property " + property + " of " + _this.model.modelName);
                delete obj[property];
            }
        }));
        return obj;
    },
    /**
     * Return the additional keyword arguments to be passed to the model
     * during instantiation.
     * @param serializerKwargs Object
     * @return Object
     */
    getCreateKwargs: /**
     * Return the additional keyword arguments to be passed to the model
     * during instantiation.
     * @param {?} obj
     * @param {?} serializerKwargs Object
     * @return {?} Object
     */
    function (obj, serializerKwargs) {
        return serializerKwargs.createKwargs || {};
    },
    /**
     * Interface for updating the instance after deserialization
     * @param instance model - The model instance
     * @param kwargs Object - Kwargs used during deserialization
     * @return Object - The final deserialized instance
     */
    postCreate: /**
     * Interface for updating the instance after deserialization
     * @param {?} instance model - The model instance
     * @return {?} Object - The final deserialized instance
     */
    function (instance) {
        return instance;
    }
})));
/**
 * Base Serializer Field Interface.
 * Used by Serializers to parse certain fields.
 *
 * Requires a "src" key, which should be an underscore, dot-delimited
 * reference to a (nested) key within the object being (de)serialized.
 *
 * Extend and use the public getSerialized() and getDeserialized() methods.
 * @type {?}
 */
export var baseField = baseObject.extend({
    isField: true,
    construct: /**
     * @param {?=} __0
     * @return {?}
     */
    function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.optional, optional = _c === void 0 ? false : _c;
        this.optional = optional;
    },
    /**
     * (De)serialize a field.
     * If the field is optional and is unset, ignore.
     * @param obj Object - The object to (de)serializer
     * @param kwargs Object - Optional kwargs to pass along
     * @param fnName string - Interface method name to call
     * @return Object - The transformed field.
     */
    _call: /**
     * (De)serialize a field.
     * If the field is optional and is unset, ignore.
     * @param {?} obj Object - The object to (de)serializer
     * @param {?} kwargs Object - Optional kwargs to pass along
     * @param {?} fnName string - Interface method name to call
     * @return {?} Object - The transformed field.
     */
    function (obj, kwargs, fnName) {
        if ((obj === undefined || obj === null) && this.optional) {
            return obj;
        }
        return this[fnName](obj, kwargs);
    },
    serialize: /**
     * @param {?} obj
     * @param {?=} kwargs
     * @return {?}
     */
    function (obj, kwargs) {
        if (kwargs === void 0) { kwargs = {}; }
        return this._call(obj, kwargs, 'getSerialized');
    },
    deserialize: /**
     * @param {?} obj
     * @param {?=} kwargs
     * @return {?}
     */
    function (obj, kwargs) {
        if (kwargs === void 0) { kwargs = {}; }
        return this._call(obj, kwargs, 'getDeserialized');
    },
    getSerialized: /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        return obj;
    },
    getDeserialized: /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        return obj;
    }
});
/* eslint-enable no-unused-vars */
/**
 * Serialize a string of characters.
 * @type {?}
 */
export var charField = baseField.extend({});
/**
 * Serialize a list.
 * \@param opts Object - Options to pass to the child field
 * \@param opts.childField baseField - The field for each child in the list
 * \@param opts.opts Object - Options to pass onto the child field
 * @type {?}
 */
export var listField = baseField.extend({
    construct: /**
     * @param {?=} __0
     * @return {?}
     */
    function (_a) {
        var _b = _a === void 0 ? {} : _a, childField = _b.childField, _c = _b.opts, opts = _c === void 0 ? {} : _c;
        this.childField = childField || this.childField;
        this.childField.construct.call(this.childField, opts);
    },
    callEach: /**
     * @param {?} obj
     * @param {?} kwargs
     * @param {?} fnName
     * @return {?}
     */
    function (obj, kwargs, fnName) {
        var _this = this;
        return obj.map((/**
         * @param {?} single
         * @return {?}
         */
        function (single) { return _this.childField[fnName].call(_this.childField, single, kwargs); }));
    },
    getSerialized: /**
     * @param {?} obj
     * @param {?} kwargs
     * @return {?}
     */
    function (obj, kwargs) {
        return this.callEach(obj, kwargs, 'getSerialized');
    },
    getDeserialized: /**
     * @param {?} obj
     * @param {?} kwargs
     * @return {?}
     */
    function (obj, kwargs) {
        return this.callEach(obj, kwargs, 'getDeserialized');
    }
});
/** @type {?} */
export var floatField = baseField.extend({
    construct: /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        baseField.construct.call(this, opts);
        this.asString = opts.asString || false;
        this.precision = opts.precision || 1;
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return parseFloat(str);
    },
    getSerialized: /**
     * @param {?} float
     * @return {?}
     */
    function (float) {
        if (this.asString) {
            return float.toFixed(this.precision);
        }
        return float;
    }
});
/** @type {?} */
export var decimalField = floatField.extend({
    construct: /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        opts.precision = 2;
        opts.asString = true;
        floatField.construct.call(this, opts);
    }
});
/** @type {?} */
export var decimalOrEmptyField = decimalField.extend({
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        if (str) {
            return parseFloat(str);
        }
        else {
            return 0;
        }
    }
});
/** @type {?} */
export var momentField = baseField.extend({
    construct: /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        baseField.construct.call(this, opts);
        if (opts.fmt) {
            this.fmt = opts.fmt;
        }
    },
    getSerialized: /**
     * @param {?} dateTime
     * @return {?}
     */
    function (dateTime) {
        return dateTime.format(this.fmt);
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return moment(str, this.fmt);
    }
});
/** @type {?} */
export var dateField = baseField.extend({
    getSerialized: /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date.format(DATE_FORMAT);
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return toDate(str);
    }
});
/** @type {?} */
export var dateOrNullField = dateField.extend({
    getSerialized: /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date ? date.format(DATE_FORMAT) : null;
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return typeof str === 'string' ? toDate(str) : null;
    }
});
/** @type {?} */
export var timeField = baseField.extend({
    getSerialized: /**
     * @param {?} time
     * @return {?}
     */
    function (time) {
        return time.format('HH:mm:ss');
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return toTime(str);
    }
});
/** @type {?} */
export var timeOrNullField = timeField.extend({
    getSerialized: /**
     * @param {?} time
     * @return {?}
     */
    function (time) {
        return time ? time.format('HH:mm:ss') : null;
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return typeof str === 'string' ? toTime(str) : null;
    }
});
/**
 * Field to serialize a date-time.
 * With the iso flag set an ISO 8601 format will be used, otherwise we
 * default to a naive date-time representation.
 * @type {?}
 */
export var dateTimeField = momentField.extend({
    fmt: 'YYYY-MM-DDTHH:mm:ss',
    construct: /**
     * @param {?=} __0
     * @return {?}
     */
    function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.optional, optional = _c === void 0 ? false : _c, _d = _b.iso, iso = _d === void 0 ? true : _d;
        this.optional = optional;
        this.iso = iso;
    },
    getSerialized: /**
     * @param {?} dateTime
     * @return {?}
     */
    function (dateTime) {
        return this.iso ? dateTime.toISOString() : dateTime.format(this.fmt);
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return moment.parseZone(str, this.iso ? undefined : this.fmt);
    }
});
/** @type {?} */
export var dateTimeOrNullField = dateTimeField.extend({
    getSerialized: /**
     * @param {?} dateTime
     * @return {?}
     */
    function (dateTime) {
        if (!dateTime) {
            return null;
        }
        return this.iso ? dateTime.toISOString() : dateTime.format(this.fmt);
    },
    getDeserialized: /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return typeof str === 'string' ? moment.parseZone(str, this.iso ? undefined : this.fmt) : null;
    }
});
/**
 * Serializer field.
 * Allows a field representing one or many objects to be serialized.
 * @type {?}
 */
export var serializerField = baseField.extend({
    ONE_TIME_KWARGS: ['many', 'noCreate'],
    construct: /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        baseField.construct.call(this, opts);
        this.serializer = opts.serializer;
        this.serializerKwargs = opts.serializerKwargs || {};
    },
    /**
     * Apply the given serializer function to the object, applying to each
     * if many is set, apply to each.
     * @param obj Object|Array - The object or array of objects.
     * @param fnName string - The name of serializer method to call.
     * @return Object|Array - The transformed instance or instances.
     */
    serializerCall: /**
     * Apply the given serializer function to the object, applying to each
     * if many is set, apply to each.
     * @param {?} obj Object|Array - The object or array of objects.
     * @param {?} fnName string - The name of serializer method to call.
     * @param {?} parentSerializerKwargs
     * @return {?} Object|Array - The transformed instance or instances.
     */
    function (obj, fnName, parentSerializerKwargs) {
        /** @type {?} */
        var kwargs = Object.assign({}, parentSerializerKwargs);
        // Ensure that one-time kwargs don't get re-used.
        this.ONE_TIME_KWARGS.forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) { return delete kwargs[key]; }));
        // Combine parent and child kwargs
        kwargs = Object.assign(kwargs, this.serializerKwargs);
        kwargs.parent = kwargs.obj;
        delete kwargs.obj;
        return this.serializer[fnName](obj, kwargs);
    },
    getSerialized: /**
     * @param {?} obj
     * @param {?} parentSerializerKwargs
     * @return {?}
     */
    function (obj, parentSerializerKwargs) {
        return this.serializerCall(obj, 'serialize', parentSerializerKwargs);
    },
    getDeserialized: /**
     * @param {?} obj
     * @param {?} parentSerializerKwargs
     * @return {?}
     */
    function (obj, parentSerializerKwargs) {
        return this.serializerCall(obj, 'deserialize', parentSerializerKwargs);
    }
});
/** @type {?} */
export var serializer = baseSerializer;
export { ɵ0 };
